var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('free-gift-page',[_c('admin-iframe',{attrs:{"slot":"contentBottom","src":_vm.remoteSrc},slot:"contentBottom"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }